import Index from "../../pages/hjwq/aniEvent/index";

const base = "aniEvent";

const routes = [
  {
    path: `/${base}/index`,
    name: `${base}-index`,
    component: Index,
  },
  {
    path: `/${base}/enter*`,
    name: `${base}-enter`,
    component: Index,
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/hjwq/aniEvent.js